 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML01_TITLE_PA from '@/components/html/01_Title_Pa'
 import HTML03_CONTENTS from '@/components/html/03_Contents'
 import HTML04_PREFACE from '@/components/html/04_Preface'
 import HTML05_INTRODUC from '@/components/html/05_Introduc'
 import HTML06_1_A_DEFI from '@/components/html/06_1_A_Defi'
 import HTML07_2_BECOMI from '@/components/html/07_2_Becomi'
 import HTML08_3_THE_FI from '@/components/html/08_3_The_Fi'
 import HTML09_4_NEW_MU from '@/components/html/09_4_New_Mu'
 import HTML10_5_MOVING from '@/components/html/10_5_Moving'
 import HTML11_6_MWANDI from '@/components/html/11_6_Mwandi'
 import HTML12_7_CROSSI from '@/components/html/12_7_Crossi'
 import HTML13_8_QUADRA from '@/components/html/13_8_Quadra'
 import HTML14_9_MUSICA from '@/components/html/14_9_Musica'
 import HTML15_10_LIFE from '@/components/html/15_10_Life'
 import HTML16_11_ENDIN from '@/components/html/16_11_Endin'
 import HTML17_EPILOGUE from '@/components/html/17_Epilogue'
 import HTML18_APPENDIX from '@/components/html/18_Appendix'
 import HTML19_NOTES from '@/components/html/19_Notes'
 import HTML20_REFERENC from '@/components/html/20_Referenc'
 import HTML21_DISCOGRA from '@/components/html/21_Discogra'
 import HTML22_INDEX from '@/components/html/22_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_Contents",
 			"name" : "html/03_Contents",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/04_Preface",
 			"name" : "html/04_Preface",
 			"component" : HTML04_PREFACE
 		},
 		{
 			"path" : "/html/05_Introduc",
 			"name" : "html/05_Introduc",
 			"component" : HTML05_INTRODUC
 		},
 		{
 			"path" : "/html/06_1_A_Defi",
 			"name" : "html/06_1_A_Defi",
 			"component" : HTML06_1_A_DEFI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js